import styled, { css } from "styled-components";

import { COLORS } from "@treelab/panda";

export const Container = styled.div<{ childrenCount: number }>`
  position: relative;
  height: 32px;
  ${({ childrenCount }) => childrenCount > 1 && "height: 72px;"}

  & > div:nth-child(2) {
    position: relative;
    right: 141.5px;
    margin-top: 8px;
    width: 274px;
  }
`;

export const Item = styled.div``;
